var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cardGridClasses},[_c('card',{class:_vm.cardClasses,attrs:{"type":"secondary","shadow":"","hover":"","bodyClasses":"p-1"}},[[_c('div',{staticClass:"ph-col-12 ph-cover-small"})]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }